import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import CategoryGrid from './components/CategoryGrid';
import AboutArticleSection from './components/AboutArticleSection';
import TrendingSection from './components/TrendingSection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'yoybuy.baby',
            url: `${import.meta.env.VITE_SITE_URL}/`,
            description: 'YOYBUY Spreadsheet — полное руководство 2026. Сравнение YOYBUY, Kakobuy и Superbuy. Пошаговый туториал, категории товаров, экономия до 30%.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${import.meta.env.VITE_SITE_URL}/?q={search_term_string}`,
              'query-input': 'required name=search_term_string'
            }
          })
        }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <CTASection />
        <CategoryGrid />
        <AboutArticleSection />
        <TrendingSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}